import React, { useState } from 'react';
import { Line } from 'react-chartjs-2';
import CTooltip from "react-tooltip-lite";
import {
  Card,
  CardBody,
  CardTitle,
  Col,
  Row,
  CardHeader,
  Button,
  Nav,
  NavItem,
  NavLink,
} from 'reactstrap';
import ErrorBoundary from 'components/ErrorBoundary';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import DownloadCSVButton from './DownlaodCSV';
import { faL } from '@fortawesome/free-solid-svg-icons';
import { reverse } from 'lodash';


ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

ChartJS.register(ArcElement, Tooltip, Legend);

const plugin = {
  beforeInit(chart) {
    console.log('be');
    // Get reference to the original fit function
    const originalFit = chart.legend.fit;

    // Override the fit function
    chart.legend.fit = function fit() {
      // Call original function and bind scope in order to use `this` correctly inside it
      originalFit.bind(chart.legend)();
      // Change the height as suggested in another answers
      this.height = this.height + 25;
    };
  },
};

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      ticks: {
        color: "#000",
        size: 15,
      },
    },
    y: {
      ticks: {
        callback: function (value, index, ticks) {
          return "$" + value / 1000 + "k";
        },
      },
      border: {
        display: false,
      },
    },
  },

  plugins: {
    tooltip: {
     callbacks: {
         label: function (context) {
        let value = context.raw;
         const formatted = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(value);
         return '$' + formatted;
      },
      },
    },
    legend: {
      display: true,

      labels: {
        padding: 15,
        usePointStyle: true,
        pointStyle: "rect",
        color: "#707070",
        font: {
          size: 14,
          weight: "600",
        },
      },
      align: "start",
    },
  },
};

const ProgramRevenue = ({ months, dispFee }) => {
  const [active, setActive] = useState('6');

  const data = {
    labels: months,
    datasets: [
      {
        label: 'Revenue',
        data: dispFee,
        borderColor: "#702C62",
        backgroundColor: "#702C62",
        pointRadius: 4.5,
      },
    ],
  };

  const handleActive = (title) => {
    setActive(title);
  };

  const getDate = () => {
    setActive("custom");
  }

  return (
    <ErrorBoundary>
      {/* <HorizontalBarChart /> */}


      <Card className="p-3 h-100 border-1 ">
        <CardHeader className="border-0 bg-white px-0 pt-0" style={{ paddingBottom: "0px" }}>
          <Row className='align-items-center'>

            <Col >
              <CTooltip
                content={
                  <div className="tip-list-info">
                    <p>
                      The replenished dispense fee revenue by month.
                    </p>
                  </div>
                }
              >
                <CardTitle className="f-20 font-weight-600 dashboard-headings">
                  <div className="d-flex justify-content-between align-items-center top_left_hed pb-1">

                    Program Revenue
                    <DownloadCSVButton
                      monthsdata={months}
                      valuedata1={dispFee}
                      heading1={["Month", "Dispense Fee Revenue"]}
                      filenamedata={"ProgramRevenue"}
                    />
                  </div>
                </CardTitle>
              </CTooltip>

            </Col>

          </Row>
        </CardHeader>
        <CardBody className='dashboard-chart-body'>
          <Line options={options} data={data} plugins={[plugin]} />
        </CardBody>
      </Card>
    </ErrorBoundary>
  );
};

export default ProgramRevenue;
